import request from '@/request'

/**
 * 账号接入跳转
 * @returns {AxiosPromise}
 */
export function access() {
  return request({
    url: '/api/v1/tik/access',
    method: 'GET',
  })
}

/**
 * tik账号注册进系统
 * @returns {AxiosPromise}
 */
export function tik_register(data) {
  return request({
    url: '/api/v1/tik/register',
    method: 'POST',
    data: data,
  })
}

/**
 * tik账号 删除数据
 * @returns {AxiosPromise}
 */
export function tik_remove(data) {
  return request({
    url: '/api/v1/tik/remove',
    method: 'POST',
    data: data,
  })
}

/**
 * tik账号列表
 * @returns {AxiosPromise}
 */
export function list(data) {
  return request({
    url: '/api/v1/tik/list',
    method: 'POST',
    data: data,
  })
}

/**
 * 修改tik账号
 * @returns {AxiosPromise}
 */
export function modify_list(data) {
  return request({
    url: '/api/v1/tik/modify_list',
    method: 'POST',
    data: data,
  })
}

/**
 * 抖音获 e chart 数据
 * @param data
 * @returns {AxiosPromise}
 */
export function chart_data(data) {
  return request({
    url: '/api/v1/tik/chart_data',
    method: 'POST',
    data: data,
  })
}

/**
 * 同步数据接口
 * @param data
 * @returns {AxiosPromise}
 */
export function upd_data(data) {
  const url = '/api/v1/tik/upd_data'
  return request({ url, method: 'POST', data })
}
